import { every } from 'lodash-es'

import isMenuScrapeable from './is-menu-scrapeable'

const isOnlyHTMLFormat = menuFormats =>
  every(menuFormats, format => isMenuScrapeable(format))

export default isOnlyHTMLFormat
